export default __webpack_public_path__ + "static/media/Plough.fdb10c98.jpeg";